module.exports = __webpack_public_path__ + "static/media/parking.5e488afa.svg";